var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickMarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2570_17164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8794 2.95401L5.66675 12.166C5.60481 12.2282 5.5312 12.2775 5.45014 12.3112C5.36909 12.3449 5.28218 12.3622 5.19441 12.3622C5.10665 12.3622 5.01974 12.3449 4.93868 12.3112C4.85763 12.2775 4.78402 12.2282 4.72208 12.166L1.15941 8.60001C1.09747 8.53782 1.02387 8.48848 0.94281 8.45481C0.861755 8.42114 0.77485 8.40381 0.687081 8.40381C0.599312 8.40381 0.512406 8.42114 0.431351 8.45481C0.350296 8.48848 0.276687 8.53782 0.214747 8.60001C0.152563 8.66194 0.103221 8.73555 0.0695536 8.81661C0.0358858 8.89767 0.0185547 8.98457 0.0185547 9.07234C0.0185547 9.16011 0.0358858 9.24701 0.0695536 9.32807C0.103221 9.40912 0.152563 9.48273 0.214747 9.54467L3.77875 13.108C4.15471 13.4833 4.66421 13.694 5.19541 13.694C5.72662 13.694 6.23612 13.4833 6.61208 13.108L15.8241 3.89801C15.8862 3.83608 15.9354 3.76251 15.969 3.68152C16.0026 3.60052 16.0199 3.5137 16.0199 3.42601C16.0199 3.33832 16.0026 3.25149 15.969 3.17049C15.9354 3.0895 15.8862 3.01593 15.8241 2.95401C15.7621 2.89182 15.6885 2.84248 15.6075 2.80881C15.5264 2.77514 15.4395 2.75781 15.3517 2.75781C15.264 2.75781 15.1771 2.77514 15.096 2.80881C15.015 2.84248 14.9414 2.89182 14.8794 2.95401Z",
    fill: "#1F8475"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2570_17164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickMarkGreen);
export default __webpack_public_path__ + "static/media/tickMarkGreen.3757618e422ab3fddd37ef0aa397f80f.svg";
export { ForwardRef as ReactComponent };